module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Cracked Pot")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Earthen vessel")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("cracked and broken")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("leaky, dry")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("good for nothing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("but to die.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Now with glue")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("and patient skill")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("re-shaped: blue-green-grey")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("beautiful and "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("capax dei ")]), _vm._v("– ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("cracks alight with holy fire")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("flaming in the dark spaces")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of my breaking heart. ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Hammered into shape")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("on the anvil of that love,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("she turns towards")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the light, vessel of mercy,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("fountain for the thirsty")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("haven from the howling")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("stiffening cold. ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("It was a happy day")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("a blackbird pecking worms")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("a chaffinch in the little tree")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("a liberated cockroach ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("scrambles out the garden door")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("welcomed to the safety")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("of the singing springing ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("scrubby grass. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ce5d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-15.vue
// module id = 102
// module chunks = 0